<template>
	<page style="background: #fff">
		<c-form ref="form">
			<c-form-item label="紧急程度" required>
				<c-radio-group name="emergency_level" :options="orderUrgencyDic"></c-radio-group>
			</c-form-item>
			<c-form-item label="报销类型" required>
				<c-select v-model="reimbType" name="reimbursement_type" :options="reimbursementTypeDic" :disabled="!!source" @change="typeHandle"></c-select>
			</c-form-item>
			<c-form-item v-show="reimbType == 1" label="关联售后工单" required>
				<c-select v-model="workOrderId" ref="orderSelect" name="order_id" async :disabled="!!source" :clear="false" @search="searchOrder">
					<template #option="{data, selected}">
						<select-option
							:name="data.name"
							:info="[
								`${data.data.customer_name||'-'} | ${data.data.create_date}`
							]"
							:selected="selected"
						></select-option>
					</template>
				</c-select>
				<info-card code="AFTERSALE_ORDER" :id="workOrderId"></info-card>
			</c-form-item>
			<c-form-item v-show="reimbType == 1" label="服务单据" required>
				<c-upload-file name="receipts_image_url" type="image" media></c-upload-file>
			</c-form-item>
			<c-form-item v-show="reimbType == 1" label="拉力报告">
				<c-upload-file name="report_image_url" type="image" media></c-upload-file>
			</c-form-item>
			<c-form-item label="报销明细" name="reimb_list" required>
				<detail-card v-for="(item, i) in reimbList" :key="i" :index="i + 1">
					<template #title>
						<p><c-state async dict="COMMONEXPENSE_ITEM" :value="item.item_code"></c-state></p>
					</template>
					<template #form>
						<detail-card-form  label="开始日期" required>
							<c-datetime v-model="item.start_date" type="date" name="start_date" @change="changeDate(item, 'start_date')"></c-datetime>
						</detail-card-form>
						<detail-card-form  label="结束日期" required>
							<c-datetime v-model="item.end_date" type="date" name="end_date" @change="changeDate(item, 'end_date')"></c-datetime>
						</detail-card-form>
						<detail-card-form label="金额" required>
							<c-input v-model="item.item_amount" type="number" name="item_amount" decimal="2" :range="[0.01, Infinity]" append-text="元"></c-input>
						</detail-card-form>
						<detail-card-form v-show="reimbType == 1" label="报销人" required>
							<c-select v-model="item.reimburser_user_id" name="reimburser_user_id" :options="memberList"></c-select>
						</detail-card-form>
						<detail-card-form label="票据凭证" :required="item.is_required_voucher == 1">
							<c-upload-file v-model="item.voucher_images" :name="item.is_required_voucher == 1 ? 'voucher_images' : ''" multiple="9" media :side="false" @click="uploadFile"></c-upload-file>
						</detail-card-form>
						<detail-card-form v-show="reimbType == 2" label="费用描述">
							<c-input v-model="item.expense_detail"></c-input>
						</detail-card-form>
					</template>
					<template #button>
						<c-link color="red" icon="tf-trash" @click="reimbList.splice(i, 1)">删除</c-link>
					</template>
				</detail-card>
				<div class="flex-end-center" style="height: .75rem; font-size: .28rem; color: #666;">合计：{{totalSum}}元</div>
				<c-button size="form" color="main" hollow prepend-icon="c-icon-add" style="width: 100%;" @click="addItemHandle">添加报销项</c-button>
			</c-form-item>
			<c-form-item label="收款账号" name="bank_account" required>
				<c-input type="hidden" name="payee_name"></c-input>
				<c-input type="hidden" name="payee_bank_name"></c-input>
				<c-input type="hidden" name="payee_card_no"></c-input>
				<c-input ref="accountInput" readonly @click.native="accountHandle"></c-input>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remarks"></c-input>
			</c-form-item>

			<!-- <cut-line></cut-line> -->

			<doc-flow ref="flow" flow="3"></doc-flow>
		</c-form>

		<template #button>
			<c-button size="form" @click="submitHandle(-1)">暂存</c-button>
			<c-button size="form" color="main" @click="submitHandle(1)">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		props: {
			id: String,
			source: String
		},

		data() {
			return {
				reimbType: '',
				workOrderId: '',
				reimbList: [],
				memberList: []
			}
		},

		computed: {
			...mapState(['orderUrgencyDic', 'reimbursementTypeDic']),

			totalSum() {
				let total = 0;
				this.reimbList.forEach(item => {
					total += parseFloat(item.item_amount) || 0;
				});
				return total;
			}
		},

		watch: {
			workOrderId(val) {
				if (val) {
					this.request({
						url: '/after/sale/order/detail',
						data: {
							id: val
						},
						success: ({detailInfo, memberList}) => {
							this.memberList = memberList.filter(item => item.is_reimbursement == 1).map(item => {
								return {
									name: item.user_realname,
									value: item.user_id
								}
							});
							this.outsourceCount = detailInfo.outsource_recruit_count;
						}
					});
				} else {
					this.memberList = [];
				}
			}
		},

		mounted() {
			if (this.id) {
				this.request({
					url: '/expense/reimbursement/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo}) => {
						this.$refs.form.set(detailInfo);
						this.$refs.orderSelect.setValueData([{
							name: detailInfo.order_number,
							value: detailInfo.order_id
						}]);
						this.reimbList = detailInfo.items;
						this.$refs.accountInput.set(`${detailInfo.payee_name} | ${detailInfo.payee_card_no}`);
					}
				})
			} else if (this.source) {
				this.request({
					url: '/after/sale/order/detail',
					data: {
						id: this.source
					},
					success: ({detailInfo}) => {
						this.$refs.form.set({
							emergency_level: 1,
							reimbursement_type: 1
						})
						this.$refs.orderSelect.setValueData([{
							name: detailInfo.order_number,
							value: detailInfo.id
						}]);
					}
				});
			} else {
				this.$refs.form.set({
					emergency_level: 1
				})
			}
		},

		methods: {
			typeHandle(data) {
				if (data.value == 2) {
					this.workOrderId = '';
				}
				this.reimbList = [];
			},
			
			searchOrder(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_ORDER',
                        is_member: 1,
                        is_reimbursement: 1,  // 仅查询当前用户可报销的工单
                        order_id: this.workOrderId,
						status: [5],
                        keyword: keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.data.order_number,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			changeDate(item, type) {
				if (item.start_date && item.end_date) {
					if (item.start_date > item.end_date) {
						this.$message({
							message: '开始时间需早于结束时间'
						});
						this.$nextTick(() => {
							item[type] = '';
						});
					}
				}
			},

			addItemHandle() {
				if (!this.reimbType) {
					this.$message({
						message: '请选择报销类型'
					});
					return;
				}
				this.globalDialog('reimbSelector', {
					props: {
						type: this.reimbType,
						multiple: true
					},
					data: {
						outsourceCount: this.outsourceCount
					}
				}, data => {
					data.forEach(item => {
						this.reimbList.push({
							item_code: item.value,
							item_amount: '',
							reimburser_user_id: '',
							is_required_voucher: item.data.is_required_voucher,
							voucher_images: '',
                            start_date: '',
                            end_date: ''
						});
					});
				});
			},

			accountHandle() {
				this.globalDialog('accountSelector', data => {
					this.$refs.accountInput.set(`${data.account_name} | ${data.card_no}`);
					this.$refs.form.set({
						payee_name: data.account_name,
						payee_bank_name: data.bank_name,
						payee_card_no: data.card_no
					})
				});
			},

			submitHandle(state) {
				this.$refs.form.submit({
					url: this.id ? '/expense/reimbursement/update' : '/expense/reimbursement/add',
					rule: {
						emergency_level: '请选择紧急程度',
						reimbursement_type: '请选择报销类型',
						order_id: [{
							type: 'empty',
							message: '请选择关联工单',
							skip: () => {
								return this.reimbType != 1;
							}
						}],
						receipts_image_url: [{
							type: 'empty',
							message: '请上传服务单据',
							skip: () => {
								return this.reimbType != 1;
							}
						}],
                        reimb_list: () => {
                            if (!this.reimbList.length || this.reimbList.find(item => {
                                return !item.start_date || !item.end_date || !item.item_amount || (this.reimbType == 1 && !item.reimburser_user_id) || (item.is_required_voucher == 1 && !item.voucher_images.length);
                            })) {
                                return '请完善报销明细';
                            }

                            if (
                                    this.reimbType == 1 && this.reimbList.find(item => {
                                        return this.reimbList.find(temp => item != temp && temp.reimburser_user_id == item.reimburser_user_id && temp.item_code == item.item_code);
                                    })
                            ) {
                                return '存在报销人和报销项相同的明细';
                            }

                            return true;
                        },
						bank_account: data => {
							if (!data.payee_name || !data.payee_bank_name || !data.payee_card_no) {
								return '请选择收款账号';
							}
							return true;
						}
					},
					dataFormatter: data => {
						data.id = this.id;
						data.status = state;
						data.items = this.reimbList.map(item => {
							return Object.assign(item, {
								item_type: 1,
								reimburser_name: this.reimbType == 1 ? this.memberList.find(temp => temp.value == item.reimburser_user_id).name : '',
								reimburser_user_id: this.reimbType == 1 ? item.reimburser_user_id : null,
								voucher_images: item.voucher_images ? item.voucher_images.join(',') : ''
							})
						});
                    	data.total_amount = this.totalSum;
						return data;
					},
					success: (data, res) => {
						this.$refs.flow.apply(state, res.transaction, () => {
							this.$message({
								message: '提交成功',
								mask: true
							});
							setTimeout(() => {
								if (this.id) {
									this.mp.navigateBack();
								} else {
									this.mp.redirectWeb('/finance/reimb/detail', {id: res.detailInfo.id});
								}
							}, 1000);
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>